<script lang="typescript">
    import { onDestroy } from "svelte";
    import { push } from "svelte-spa-router";

    onDestroy(() => window.scrollTo(0, 0));
</script>

<section class="justify-center bg-primary h-screen overflow-y-hidden">
    <div class="page-container h-full bg-primary flex flex-col justify-center items-center">
        <h1 class="text-5xl mb-8 text-white font-normal">Contact Lens Subscrption</h1>
        <img src="/img/contact-lens/subscription-process.png" />
        <button
            class="btn-secondary btn-sm px-4 mt-10 lg:px-8"
            type="button"
            on:click={() => push("/")}
        >
            Start again
        </button>
    </div>
</section>
